export default __webpack_public_path__ + "static/bg-app--mobile-78ffbf20f691df17edee3102b06f501c.jpg";